module.exports = __webpack_public_path__ + "static/media/armandthiery3.6e6e7c4a.jpg";